import axios from "axios";
import { ENDPOINT } from "constants/environment";
import { encryptData } from "helpers";
import { decryptData } from "helpers";
import { getHeaderConfig } from "helpers";
import { consoleLog } from "helpers";

export const getFaqAPI = async (isLoading, accessJWT, payload) => {
  try {
    isLoading(true);
    const config = getHeaderConfig(null, accessJWT);

    const body = {
      page: payload.pageIndex + 1,
      limit: payload.limit,
    };
    const response = await axios.post(
      `${ENDPOINT}/app/v1/faqs`,
      encryptData(body),
      config
    );

    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData && parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);
      consoleLog([parsedResponseData, "response123"]);
      return parsedResponseData?.data;
    }
    if (isLoading) isLoading(false);
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error fetching data:", error);
    return null;
  }
};

export const getFilterFaqAPI = async (payload, isLoading, accessJWT) => {
  consoleLog([payload, "payload"]);
  try {
    isLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    const body = {
      search: payload.searchQuery,
      page: payload.pageIndex + 1,
      limit: payload.limit,
    };

    const response = await axios.post(
      `${ENDPOINT}/app/v1/faq/search?`,
      encryptData(body),
      config
    );

    const parsedResponseData = JSON.parse(decryptData(response?.data));

    if (parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);
      consoleLog([parsedResponseData.data, "searchRes"]);
      consoleLog([
        parsedResponseData.data.pagination?.totalPages,
        "parsedResponseData.data.pagination?.totalPages",
      ]);

      return {
        data: parsedResponseData?.data.data,
        totalPages: parsedResponseData.data.pagination?.totalPages,
      };
    }

    if (isLoading) isLoading(false);
    throw new Error("Error fetching data");
  } catch (error) {
    isLoading(false);
    console.error("Error fetching data:", error);
    return { data: [], totalPages: 0 };
  }
};

export const createOrUpdateFaqAPI = async (args, isLoading, accessJWT) => {
  const API_URL = `${ENDPOINT}/app/v1/faq`;
  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.post(API_URL, encryptData(args), config);
    const parsedResponseData = JSON.parse(decryptData(response?.data));

    if (isLoading) isLoading(false);

    if (parsedResponseData?.statusCode === 200) {
      return parsedResponseData?.data;
    } else {
      throw new Error(parsedResponseData?.message || "Unknown error");
    }
  } catch (error) {
    if (isLoading) isLoading(false);
    const message =
      error?.response?.data?.[0]?.message ||
      error?.message ||
      "Something went wrong";
    return { error: true, message };
  }
};

export const deleteFaqAPI = async (args, isLoading, accessJWT) => {
  const API_URL = `${ENDPOINT}/app/v1/faq/key?id=${args.id}`;
  consoleLog([args, "args"]);
  try {
    if (isLoading) isLoading(true);
    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.delete(API_URL, config);
    const parsedResponseData = JSON.parse(decryptData(response?.data));
    if (parsedResponseData) {
      if (isLoading) isLoading(false);
      return parsedResponseData;
    }
    if (isLoading) isLoading(false);
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error deleting FAQ:", error);
    return null;
  }
};
